<template>
    <section class="module-driver">
        <div class="container">
            <div class="module-driver__wrapper" v-if="moduleData">
                <LogoBottom class="module-driver__logo" data-aos="fade-in" data-aos-delay="600"></LogoBottom>
                <h2 class="module-driver__subtitle" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out-back">{{ moduleData.lead }}</h2>
                <a 
                    :href="moduleData.showMoreUrl" 
                    class="module-driver__btn" 
                    data-aos="zoom-in" 
                    data-aos-offset="0"
                    data-aos-duration="1000"
                    data-aos-delay="600"
                    data-aos-easing="ease-out-back"
                >
                    <span>{{ moduleData.showMoreTitle }}</span>
                </a>
                <h2 class="module-driver__subtitle" data-aos="fade-up" data-aos-duration="1000" data-aos-easing="ease-in-out-back">lub pobierz aplikację</h2>


                <div class="module-driver__icons">
                    <a href="https://play.google.com/store/apps/details?id=pl.tvp.krainaAbc" target="_blank"
                        class="module-driver__icon"                     
                        data-aos="fade-in" 
                        data-aos-duration="1000"
                        data-aos-delay="1000"
                        data-aos-easing="ease-out-back"
                    >
                        <img src="/templates/xhtml/krainaabc/src/assets/images/google_play.png" alt=""/>
                    </a>
                    <a href="https://apps.apple.com/pl/app/kraina-abc/id1618917144" target="_blank"
                        class="module-driver__icon"                     
                        data-aos="zoom-in" 
                        data-aos-duration="1000"
                        data-aos-delay="1000"
                        data-aos-easing="ease-out-back"
                    >
                        <img src="/templates/xhtml/krainaabc/src/assets/images/app_store.png" alt=""/>
                    </a>   
                    <a href="https://appgallery.cloud.huawei.com/marketshare/app/C107151661" target="_blank"
                        class="module-driver__icon"                     
                        data-aos="zoom-in" 
                        data-aos-duration="1000"
                        data-aos-delay="1000"
                        data-aos-easing="ease-out-back"
                    >
                        <img src="/templates/xhtml/krainaabc/src/assets/images/app_gallery.png" alt=""/>
                    </a>         
                </div>

                <span class="module-driver__in">Poznaj krainę ABC</span>
                <IconScroll @click="scrollHandler()" class="module-driver__scroll"></IconScroll>
            </div>
        </div>

        <video
            data-aos="fade-in" 
            data-aos-duration="500"
            playsinline autoplay muted loop
            class="module-driver__video"
            src="https://s.tvp.pl/files/portale-v4/krainaabc/video/driver.mp4"
            type="video/mp4"
            :poster="getVideoPoster(moduleData.image)"
        ></video>
    </section>
</template>

<script>
import IconScroll from "../elements/icons/IconScroll.vue";
import LogoBottom from "../elements/LogoBottom.vue";
import { parseImageUrl } from '../../mixins/useParseImage';
export default {
    name: "ModuleDriver",
    components: {
        IconScroll,
        LogoBottom
    },
    mixins: [parseImageUrl],
    props: {
        module: {
            type: Object,
            required: true,
        }
    },
    computed: {
        moduleData() {
            if(this.module && this.module.items) {
                return {
                    title: this.module.items[0].title,
                    lead: this.module.items[0].lead,
                    image: this.module.items[0].image,
                    showMoreUrl: this.module.show_more.url,
                    showMoreTitle: this.module.show_more.title
                }
            }
            return null;
        }
    },
    methods: {
        scrollHandler() {
            const headerHeight = document.querySelector('.header').clientHeight;
            const elToScroll = document.querySelector('.module-driver');
            const elToScrollPos = elToScroll ? elToScroll.getBoundingClientRect().bottom - headerHeight : null;
            const startPos = window.pageYOffset;

            if(elToScrollPos) {
                window.scrollTo({
                    top: startPos + elToScrollPos,
                    behavior: 'smooth'
                });
            }
        },
        getVideoPoster(img) {
            let url = '';
            if (img && img.url) {
                url = parseImageUrl(img.url,1920,1080);
            }
            return url;
        },
    }
};
</script>